/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';

// 特殊页面
import noAuth from '../components/noAuth';

// 登录
import login from '../components/login/login';
import forget from '../components/login/forgetPwd';
import userInfo from '../components/userInfo/userInfo';

// 物业管理
import propertyRole from '../components/property/role/propertyRole';
import propertyAddRole from '../components/property/role/propertyAddRole';
import company from '../components/property/company/company';
import addCompany from '../components/property/company/addCompany';
import auditCompany from '../components/property/company/auditCompany';
import propertyAccount from '../components/property/account/propertyAccount';
import editPropertyAccount from '../components/property/account/editPropertyAccount';

// 基础数据
import community from '../components/baseData/community/community';
import addCommunity from '../components/baseData/community/addCommunity';
import communityConfig from '../components/baseData/community/communityConfig';
import building from '../components/baseData/building/building';
import addBuilding from '../components/baseData/building/addBuilding';
import unit from '../components/baseData/unit/unit';
import addUnit from '../components/baseData/unit/addUnit';
import room from '../components/baseData/room/room';
import roomInfo from '../components/baseData/room/roomInfo';
import addRoom from '../components/baseData/room/addRoom';
import importRoom from '../components/baseData/room/importRoom';
import location from '../components/baseData/location/location';
import addLocation from '../components/baseData/location/addLocation';

// 管理员中心
import role from '../components/managerCenter/role/role';
import addRole from '../components/managerCenter/role/addRole';
import manageApiAuth from '../components/managerCenter/role/roleAuth';
import manageViewAuth from '../components/managerCenter/role/roleAuth';

import propertyApiAuth from '../components/managerCenter/role/roleAuth';
import propertyViewAuth from '../components/managerCenter/role/roleAuth';

import account from '../components/managerCenter/account/account';
import addAccount from '../components/managerCenter/account/addAccount';
import operationLog from '../components/managerCenter/operationLog';

// 会员管理
import member from '../components/member/memberInfo/member';
import housingInfo from '../components/member/memberInfo/housingInfo';
import memberDetail from '../components/member/memberInfo/memberDetail';
import householdAuthRecord from '../components/member/householdAuthRecord/householdAuthRecord';
import householdAuthDetail from '../components/member/householdAuthRecord/householdAuthDetail';
import passport from '../components/member/passport';

// 设备管理
import smartDoor from '../components/device/smartDoor/smartDoor';
import editSmartDoor from '../components/device/smartDoor/editSmartDoor';
import smartDoorDetail from '../components/device/smartDoor/smartDoorDetail';
import keyList from '../components/device/keyList/keyList';
import allocation from '../components/device/keyList/allocation';
import batchAllocation from '../components/device/keyList/batchAllocation';
import keyApply from '../components/device/keyApply/keyApply';
import keyApplyDetail from '../components/device/keyApply/keyApplyDetail';
import cardRecord from '../components/device/cardRecord';
import openLog from '../components/device/openLog';
import product from '../components/device/product/product';
import addProduct from '../components/device/product/addProduct';
import editProduct from '../components/device/product/editProduct';
import device from '../components/device/device/device';
import addDevice from '../components/device/device/addDevice';

// 分类
import productCate from '../components/device/category/product/productCate';
import addProductCate from '../components/device/category/product/addProductCate';

import locationCate from '../components/device/category/location/locationCate';
import addLocationCate from '../components/device/category/location/addLocationCate';

import apiCate from '../components/device/category/api/apiCate';
import addApiCate from '../components/device/category/api/addApiCate';

import msgtplCate from '../components/device/category/msgTpl/msgtplCate';
import addMsgtplCate from '../components/device/category/msgTpl/addMsgtplCate';

import docCate from '../components/device/category/doc/docCate';
import addDocCate from '../components/device/category/doc/addDocCate';


// 运营管理
import systemMsg from '../components/marketing/systemMsg/systemMsg';
import addSystemMsg from '../components/marketing/systemMsg/addSystemMsg';
import msgTemplate from '../components/marketing/msgTemplate/msgTemplate';
import addMsgTemplate from '../components/marketing/msgTemplate/addMsgTemplate';
import push from '../components/marketing/push/push';
import addPush from '../components/marketing/push/addPush';
import pushDetail from '../components/marketing/push/pushDetail';
import document from '../components/marketing/document/document';
import addDocument from '../components/marketing/document/addDocument';

import advert from '../components/marketing/advert/advert';
import addAdvert from '../components/marketing/advert/addAdvert';

import feedBack from '../components/marketing/feedBack';

// 系统设置
import appVersion from '../components/systemSet/appVersion/appVersion';
import addVersion from '../components/systemSet/appVersion/addVersion';
import communityApp from '../components/systemSet/communityApp/communityApp';
import addCommunityApp from '../components/systemSet/communityApp/addCommunityApp';
import editCommunityFun from '../components/systemSet/communityApp/editCommunityFun';
import stewardApp from '../components/systemSet/stewardApp/stewardApp';
import addStewardApp from '../components/systemSet/stewardApp/addStewardApp';
import editStewardFun from '../components/systemSet/stewardApp/editStewardFun';
import api from '../components/systemSet/api/api';
import addApi from '../components/systemSet/api/addApi';

// 工程管理
import projectAccount from '../components/projectAccount/projectAccount';
import addProjectAccount from '../components/projectAccount/addProjectAccount';

import testSetFormL from '../components/test/testSetForm_1';
import testSetForm from '../components/test/testSetForm';

Vue.use(Router);

let routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    filePath: '../components/login/login',
    component: login
  },
  {
    path: '/noAuth',
    name: 'noAuth',
    component: noAuth
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    filePath: '../components/userInfo/userInfo',
    component: userInfo,
    meta: {title: '账号信息', breadNumber: 0}
  },
  {
    path: '/forget',
    name: 'forget',
    filePath: '',
    component: forget
  },
  {
    path: '/projectAccount',
    name: 'projectAccount',
    filePath: '',
    component: projectAccount,
    meta: {title: '工程账号管理', breadNumber: 0}
  },
  {
    path: '/projectAccount/add',
    name: 'addProjectAccount',
    filePath: '',
    component: addProjectAccount,
    meta: {title: '新增工程账号', breadNumber: 1}
  },
  {
    path: '/document',
    name: 'document',
    filePath: '',
    component: document,
    meta: {title: '文档管理', breadNumber: 0}
  },
  {
    path: '/appVersion',
    name: 'appVersion',
    filePath: '',
    component: appVersion,
    meta: {title: 'app版本管理', breadNumber: 0}
  },
  {
    path: '/appVersion/add',
    name: 'addVersion',
    filePath: '',
    component: addVersion,
    meta: {title: '新增版本', breadNumber: 1}
  },
  {
    path: '/communityApp',
    name: 'communityApp',
    filePath: '',
    component: communityApp,
    meta: {title: '社区app应用配置', breadNumber: 0}
  },
  {
    path: '/communityApp/add',
    name: 'addCommunityApp',
    filePath: '',
    component: addCommunityApp,
    meta: {title: '新增社区app应用', breadNumber: 1}
  },
  {
    path: '/communityApp/fun',
    name: 'editCommunityFun',
    filePath: '',
    component: editCommunityFun,
    meta: {title: '编辑社区app功能', breadNumber: 1}
  },
  {
    path: '/stewardApp',
    name: 'stewardApp',
    filePath: '',
    component: stewardApp,
    meta: {title: '管家app应用配置', breadNumber: 0}
  },
  {
    path: '/stewardApp/add',
    name: 'addStewardApp',
    filePath: '',
    component: addStewardApp,
    meta: {title: '新增管家app应用', breadNumber: 1}
  },
  {
    path: '/stewardApp/fun',
    name: 'editStewardFun',
    filePath: '',
    component: editStewardFun,
    meta: {title: '编辑管家app功能', breadNumber: 1}
  },
  {
    path: '/document/add',
    name: 'addDocument',
        filePath: '',
    component: addDocument,
    meta: {title: '文添加档', breadNumber: 1}
  },
  {
    path: '/advert',
    name: 'advert',
        filePath: '',
    component: advert,
    meta: {title: 'APP广告', breadNumber: 0}
  },
  {
    path: '/advert/add',
    name: 'addAdvert',
        filePath: '',
    component: addAdvert,
    meta: {title: '新增APP广告', breadNumber: 1}
  },
  {
    path: '/msgTemplate',
    name: 'msgTemplate',
        filePath: '',
    component: msgTemplate,
    meta: {title: '消息模板', breadNumber: 0}
  },
  {
    path: '/msgTemplate/add',
    name: 'addMsgTemplate',
        filePath: '',
    component: addMsgTemplate,
    meta: {title: '添加模板', breadNumber: 1}
  },
  {
    path: '/push',
    name: 'push',
        filePath: '',
    component: push,
    meta: {title: '推送通知', breadNumber: 0}
  },
  {
    path: '/push/add',
    name: 'addPush',
        filePath: '',
    component: addPush,
    meta: {title: '新增推送', breadNumber: 1}
  },
  {
    path: '/push/detail',
    name: 'pushDetail',
        filePath: '',
    component: pushDetail,
    meta: {title: '推送详情', breadNumber: 1}
  },
  {
    path: '/systemMsg',
    name: 'systemMsg',
    filePath: '',
    component: systemMsg,
    meta: {title: '系统消息', breadNumber: 0}
  },
  {
    path: '/systemMsg/add',
    name: 'addSystemMsg',
    filePath: '',
    component: addSystemMsg,
    meta: {title: '新增系统消息', breadNumber: 1}
  },
  {
    path: '/feedBack',
    name: 'feedBack',
    filePath: '',
    component: feedBack,
    meta: {title: '用户反馈', breadNumber: 0}
  },
  {
    path: '/product',
    name: 'product',
    filePath: '',
    component: product,
    meta: {title: '产品列表', breadNumber: 0}
  },
  {
    path: '/product/add',
    name: 'addProduct',
    filePath: '',
    component: addProduct,
    meta: {title: '新增产品', breadNumber: 1}
  },
  {
    path: '/product/edit',
    name: 'editProduct',
    filePath: '',
    component: editProduct,
    meta: {title: '编辑功能', breadNumber: 1}
  },
  {
    path: '/device',
    name: 'device',
    filePath: '',
    component: device,
    meta: {title: '设备', breadNumber: 0}
  },
  {
    path: '/device/add',
    name: 'addDevice',
    filePath: '',
    component: addDevice,
    meta: {title: '添加设备', breadNumber: 1}
  },
  {
    path: '/cardRecord',
    name: 'cardRecord',
    filePath: '',
    component: cardRecord,
    meta: {title: '制卡记录', breadNumber: 0}
  },
  {
    path: '/openLog',
    name: 'openLog',
    filePath: '',
    component: openLog,
    meta: {title: '开门日志', breadNumber: 0}
  },

  {
    path: '/msgtplCate',
    name: 'msgtplCate',
    filePath: '',
    component: msgtplCate,
    meta: {title: '消息分类', breadNumber: 0}
  },
  {
    path: '/msgtplCate/add',
    name: 'addMsgtplCate',
    filePath: '',
    component: addMsgtplCate,
    meta: {title: '新增消息分类', breadNumber: 1}
  },

  {
    path: '/docCate',
    name: 'docCate',
    filePath: '',
    component: docCate,
    meta: {title: '文档分类', breadNumber: 0}
  },
  {
    path: '/docCate/add',
    name: 'addDocCate',
    filePath: '',
    component: addDocCate,
    meta: {title: '新增文档分类', breadNumber: 1}
  },

  {
    path: '/locationCate',
    name: 'locationCate',
    filePath: '',
    component: locationCate,
    meta: {title: '位置分类', breadNumber: 0}
  },
  {
    path: '/locationCate/add',
    name: 'addLocationCate',
    filePath: '',
    component: addLocationCate,
    meta: {title: '新增位置分类', breadNumber: 1}
  },

  {
    path: '/apiCate',
    name: 'apiCate',
    filePath: '',
    component: apiCate,
    meta: {title: 'api分类', breadNumber: 0}
  },
  {
    path: '/apiCate/add',
    name: 'addApiCate',
    filePath: '',
    component: addApiCate,
    meta: {title: '新增api分类', breadNumber: 1}
  },

  {
    path: '/api',
    name: 'api',
    filePath: '',
    component: api,
    meta: {title: 'api管理', breadNumber: 0}
  },
  {
    path: '/api/add',
    name: 'addApi',
    filePath: '',
    component: addApi,
    meta: {title: '新增api', breadNumber: 1}
  },
  {
    path: '/productCate',
    name: 'productCate',
    filePath: '',
    component: productCate,
    meta: {title: '产品分类', breadNumber: 0}
  },
  {
    path: '/productCate/add',
    name: 'addProductCate',
    filePath: '',
    component: addProductCate,
    meta: {title: '新增分类', breadNumber: 1}
  },
  {
    path: '/keyApply',
    name: 'keyApply',
    filePath: '',
    component: keyApply,
    meta: {title: '钥匙申请', breadNumber: 0}
  },
  {
    path: '/keyApply/detail',
    name: 'keyApplyDetail',
    filePath: '',
    component: keyApplyDetail,
    meta: {title: '钥匙申请详情', breadNumber: 1}
  },
  {
    path: '/keyList',
    name: 'keyList',
    filePath: '',
    component: keyList,
    meta: {title: '住户钥匙列表', breadNumber: 0}
  },
  {
    path: '/keyList/alloc',
    name: 'allocation',
    filePath: '',
    component: allocation,
    meta: {title: '分配钥匙', breadNumber: 1}
  },
  {
    path: '/keyList/batchAlloc',
    name: 'batchAllocation',
    filePath: '',
    component: batchAllocation,
    meta: {title: '批量分配钥匙', breadNumber: 1}
  },
  {
    path: '/smartDoor',
    name: 'smartDoor',
    filePath: '',
    component: smartDoor,
    meta: {title: '门禁设备', breadNumber: 0}
  },
  {
    path: '/smartDoor/edit',
    name: 'editSmartDoor',
    filePath: '',
    component: editSmartDoor,
    meta: {title: '编辑门禁设备', breadNumber: 1}
  },
  {
    path: '/smartDoor/detail',
    name: 'smartDoorDetail',
    filePath: '',
    component: smartDoorDetail,
    meta: {title: '门禁设备详情', breadNumber: 1}
  },
  {
    path: '/householdAuthRecord',
    name: 'householdAuthRecord',
    filePath: '',
    component: householdAuthRecord,
    meta: {title: '住户认证记录', breadNumber: 0}
  },
  {
    path: '/householdAuthRecord/detail',
    name: 'householdAuthDetail',
    filePath: '',
    component: householdAuthDetail,
    meta: {title: '住户认证详情', breadNumber: 1}
  },
  {
    path: '/passport',
    name: 'passport',
    filePath: '',
    component: passport,
    meta: {title: '社区身份证', breadNumber: 0}
  },
  {
    path: '/member',
    name: 'member',
    filePath: '',
    component: member,
    meta: {title: '会员信息', breadNumber: 0}
  },
  {
    path: '/member/detail',
    name: 'memberDetail',
    filePath: '',
    component: memberDetail,
    meta: {title: '会员详情', breadNumber: 1}
  },
  {
    path: '/member/housingInfo',
    name: 'housingInfo',
    filePath: '',
    component: housingInfo,
    meta: {title: '住房信息', breadNumber: 1}
  },
  {
    path: '/room',
    name: 'room',
    filePath: '',
    component: room,
    meta: {title: '房间管理', breadNumber: 0}
  },
  {
    path: '/room/info',
    name: 'roomInfo',
    filePath: '',
    component: roomInfo,
    meta: {title: '住户信息', breadNumber: 1}
  },
  {
    path: '/room/add',
    name: 'addRoom',
    filePath: '',
    component: addRoom,
    meta: {title: '添加房间', breadNumber: 1}
  },
  {
    path: '/room/import',
    name: 'importRoom',
    filePath: '',
    component: importRoom,
    meta: {title: '导入房间', breadNumber: 1}
  },
  {
    path: '/location',
    name: 'location',
    filePath: '',
    component: location,
    meta: {title: '位置管理', breadNumber: 0}
  },
  {
    path: '/location/add',
    name: 'addLocation',
    filePath: '',
    component: addLocation,
    meta: {title: '新增位置', breadNumber: 1}
  },
  {
    path: '/unit',
    name: 'unit',
    filePath: '',
    component: unit,
    meta: {title: '单元管理', breadNumber: 0}
  },
  {
    path: '/addUnit',
    name: 'addUnit',
    filePath: '',
    component: addUnit,
    meta: {title: '添加单元', breadNumber: 1}
  },
  {
    path: '/propertyAccount',
    name: 'propertyAccount',
    filePath: '',
    component: propertyAccount,
    meta: {title: '物业账号管理', breadNumber: 0}
  },
  {
    path: '/propertyAccount/edit',
    name: 'editPropertyAccount',
    filePath: '',
    component: editPropertyAccount,
    meta: {title: '编辑物业账号', breadNumber: 1}
  },
  {
    path: '/company',
    name: 'company',
    filePath: '',
    component: company,
    meta: {title: '物业公司管理', breadNumber: 0}
  },
  {
    path: '/company/add',
    name: 'addCompany',
    filePath: '',
    component: addCompany,
    meta: {title: '新增物业公司', breadNumber: 1}
  },
  {
    path: '/company/audit',
    name: 'auditCompany',
    filePath: '',
    component: auditCompany,
    meta: {title: '物业公司审核', breadNumber: 1}
  },
  {
    path: '/propertyRole',
    name: 'propertyRole',
    component: propertyRole,
    filePath: '',
    menuKey: 'propertyRole',
    meta: {
      title: '物业角色',
      breadNumber: 0,
      btnList: [
        {title: '新增按钮', key: 'addbtn'},
        {title: '权限配置', key: 'config'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
    }
  },
  {
    path: '/propertyRole/add',
    name: 'propertyAddRole',
    filePath: '',
    component: propertyAddRole,
    meta: {title: '新增物业角色', breadNumber: 1}
  },
  {
    path: '/community',
    name: 'community',
    filePath: '',
    component: community,
    meta: {title: '小区管理', breadNumber: 0}
  },
  {
    path: '/community/add',
    name: 'addCommunity',
    filePath: '',
    component: addCommunity,
    meta: {title: '新增小区', breadNumber: 1}
  },
  {
    path: '/community/config',
    name: 'communityConfig',
    filePath: '',
    component: communityConfig,
    meta: {title: '小区配置', breadNumber: 1}
  },
  {
    path: '/building',
    name: 'building',
    filePath: '',
    component: building,
    meta: {title: '楼栋管理', breadNumber: 0}
  },
  {
    path: '/building/add',
    name: 'addBuilding',
    filePath: '',
    component: addBuilding,
    meta: {title: '新增楼栋', breadNumber: 1}
  },
  {
    path: '/role',
    name: 'role',
    filePath: '',
    component: role,
    meta: {title: '管理员角色管理', breadNumber: 0}
  },
  {
    path: '/role/add',
    name: 'addRole',
    filePath: '',
    component: addRole,
    meta: {title: '新增管理员角色', breadNumber: 1}
  },
  {
    path: '/propertyRole/api',
    name: 'propertyApiAuth',
    component: propertyApiAuth,
    meta: {title: '物业角色API权限', breadNumber: 1}
  },
  {
    path: '/propertyRole/view',
    name: 'propertyViewAuth',
    component: propertyViewAuth,
    meta: {title: '物业角色视图权限', breadNumber: 1}
  },
  {
    path: '/role/api',
    name: 'manageApiAuth',
    component: manageApiAuth,
    meta: {title: '配置API权限', breadNumber: 1}
  },
  {
    path: '/role/view',
    name: 'manageViewAuth',
    component: manageViewAuth,
    filePath: '',
    meta: {title: '配置视图权限', breadNumber: 1}
  },
  {
    path: '/account',
    name: 'account',
    filePath: '',
    component: account,
    meta: {title: '管理员账号管理', breadNumber: 0}
  },
  {
    path: '/account/add',
    name: 'addAccount',
    filePath: '',
    component: addAccount,
    meta: {title: '新增管理员账号', breadNumber: 1}
  },
  {
    path: '/operationLog',
    name: 'operationLog',
    filePath: '',
    component: operationLog,
    meta: {title: '管理员操作日志', breadNumber: 0}
  }
];
let authRoute = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/noAuth',
    name: 'noAuth',
    component: noAuth
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    component: userInfo,
    meta: {title: '账号信息', breadNumber: 0}
  },
  {
    path: '/forget',
    name: 'forget',
    component: forget,
    meta: {title: '忘记密码', breadNumber: 0}
  },
  {
    path: '/testSetFormL',
    name: 'testSetFormL',
    component: testSetFormL,
    meta: {title: '测试表单', breadNumber: 0}
  },
  {
    path: '/testSetForm',
    name: 'testSetForm',
    component: testSetForm,
    meta: {title: '测试表单赋值', breadNumber: 0}
  }
];

export default new Router({
  routes: [
    // ...routes
    ...authRoute
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js